import { memo } from 'react';
import { Outlet } from 'react-router-dom';

import { UserDetailsLayout } from './user-details-layout.component';
import { UserDetailsTabs } from './user-details-tabs.component';

export const UserDetailsPage = memo(() => (
  <UserDetailsLayout>
    <UserDetailsTabs>
      <Outlet />
    </UserDetailsTabs>
  </UserDetailsLayout>
));
